var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSwap(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Iconly/Regular/Outline/Swap"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Swap"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Stroke 1",
    d: "M20.3477 7.01373C20.8065 7.01373 21.1856 7.35424 21.2456 7.79602L21.2539 7.91883V24.3528C21.2539 24.8527 20.8482 25.2579 20.3477 25.2579C19.8889 25.2579 19.5097 24.9174 19.4497 24.4756L19.4414 24.3528V7.91883C19.4414 7.41896 19.8471 7.01373 20.3477 7.01373Z",
    fill: "#2F54EB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 3",
    d: "M24.6327 18.7711C24.9858 18.4168 25.5596 18.4155 25.9144 18.7681C26.2369 19.0887 26.2673 19.5915 26.0048 19.9464L25.9173 20.0481L20.99 24.992C20.668 25.3151 20.1626 25.3445 19.8072 25.0801L19.7054 24.992L14.7781 20.0481C14.425 19.6939 14.4263 19.1208 14.7811 18.7681C15.1036 18.4475 15.6071 18.4195 15.9613 18.6832L16.0627 18.7711L20.3472 23.0697L24.6327 18.7711Z",
    fill: "#2F54EB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 5",
    d: "M8.35107 3.73901C8.80987 3.73901 9.18904 4.07952 9.24905 4.5213L9.25732 4.64412V21.0781C9.25732 21.578 8.85158 21.9832 8.35107 21.9832C7.89228 21.9832 7.51311 21.6427 7.4531 21.2009L7.44482 21.0781V4.64412C7.44482 4.14424 7.85057 3.73901 8.35107 3.73901Z",
    fill: "#2F54EB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 7",
    d: "M7.70885 4.00492C8.03089 3.6818 8.53628 3.65242 8.89166 3.9168L8.99344 4.00492L13.9208 8.94879C14.2738 9.30307 14.2725 9.87615 13.9178 10.2288C13.5953 10.5494 13.0918 10.5774 12.7376 10.3137L12.6362 10.2258L8.35087 5.92587L4.06612 10.2258C3.74513 10.5479 3.24173 10.5783 2.88634 10.3162L2.7845 10.2288C2.46201 9.9082 2.4316 9.40544 2.69402 9.05051L2.78153 8.94879L7.70885 4.00492Z",
    fill: "#2F54EB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSwap);
export default __webpack_public_path__ + "static/media/icon-swap.98eaa5c9f3e4b30d8a54d7f08cad12b4.svg";
export { ForwardRef as ReactComponent };